import { render, staticRenderFns } from "./index-courses.vue?vue&type=template&id=6e97bf94&scoped=true&"
import script from "./index-courses.vue?vue&type=script&lang=js&"
export * from "./index-courses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e97bf94",
  null
  
)

export default component.exports